import { Injectable } from '@angular/core';
import { IFilterListService } from './ifilter-list.service';
import { map } from 'rxjs';
import { Selectable } from '../models/types/selectable.type';
import { GetQuery } from '../../models/shared/enums/get-query.enum';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { WrapperResultGraphQL } from '../../models/shared/types/wrapper-result-graphql.type';
import { PageInfo } from '../../models/shared/types/page-info.type';
import { Brand } from '../../models/common/brand.model';

@Injectable({
  providedIn: 'root'
})
export class BrandFilterService extends IFilterListService<Brand> {
  pageInfo: PageInfo = { hasPreviusPage: false, hasNextPage: false, startCursor: null, endCursor: null };

  search(searchText: string, variables, isFirst: boolean): void {
    if (searchText || isFirst) this.pageInfo = { ...this.pageInfo, endCursor: null, startCursor: null };
    this.graphQlService.getData<Brand>(GetQuery.GET_BRANDS_NO_IDS, { search: searchText, companyId: Number(this.appService.companyId), first: variables.first, after: this.pageInfo.endCursor })
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        map(res => res['data']['brands'])
      )
      .subscribe({
        next: (res: WrapperResultGraphQL<any>) => {
          let datasource: Array<Selectable<Brand>> = [];
          if (this.pageInfo.endCursor) {
            const actualValue = this.datasource.getValue();
            datasource = [...actualValue, ...res.nodes.map(el => ({ brandId: el.brandId, brandName: el.brand.name, hasSizeGroup: el.hasSizeGroup,  displayId: el.brandId!, displayName: el.brand.name, disabled: false, selected: false }))];
          } else {
            datasource = res.nodes.map(el => ({ brandId: el.brandId, brandName: el.brand.name, hasSizeGroup: el.hasSizeGroup,  displayId: el.brandId!, displayName: el.brand.name, disabled: false, selected: false }));
          }

          this.pageInfo = res.pageInfo;
          this.datasource.next(datasource);
        }
      })
  }
}
